import React from "react";
import { Col, Container, Row } from "reactstrap";

//Images
import Widgets from "./Widgets";
import PaymentCategoryChart from "./PaymentCategoryChart";
import DistributionByGender from "./DistributionByGender";
import PaymentCategoryAndRegion from "./PaymentCategoryAndRegion";
import RecentPayments from "./RecentPayments";
import Header from "./Header";
import BreadCrumb from "Components/Common/BreadCrumb";
import { useProfile } from "Components/Hooks/UserHooks";

const AgencyDashboard = () => {
  const { userProfile } = useProfile();
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={`${userProfile?.agency?.name || ""} Dashboard`}
            pageTitles={[{ title: "Dashboard", link: "/dashboard" }]}
          />
          <Header />

          <Widgets />
          <Row>
            <Col xl={4}>
              <PaymentCategoryChart />
            </Col>
            <Col xl={8}>
              <RecentPayments />
            </Col>
          </Row>
          <Row>
            <Col xl={8}>
              <PaymentCategoryAndRegion />
            </Col>
            <Col xl={4}>
              <DistributionByGender />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AgencyDashboard;
